import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from './base-data-service';
import { UploadDocRequest, UploadDocResponse } from './def/upload-doc';
import { GlobalVariablesService } from './global-variables.service';

@Injectable({
  providedIn: 'root'
})
export class UploadFileService extends BaseDataService {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  uploadDocument(params: UploadDocRequest): Observable<UploadDocResponse> {
    const url = `${this.serviceBaseUrl}/document/upload-document`;
    return this.post<UploadDocResponse>(url, { body: params });
  }
}
